export default __webpack_public_path__ + "static/media/splash.3dcd9938.jpg";